export const PATH_NAME = {
  ROOT: "/",
  ERROR_404: "/404",
  ERROR_403: "/403",
  LOGIN: "/login",
  SIGNUP: "/signup",
  EntityCreation: "/entity-creation",
  DASHBOARD: "/admin/dashboard",
  Employees: "/admin/employees-management",
  NewEmployee: "/admin/employees-management/new-employee",
  DailyAttendance: "/admin/daily-attendance",
  LEAVE_MANAGEMENT: "/admin/leave-management",
  LeaveDetails: "/admin/leave-management/:leaveid",
  EditEmployee: "/admin/employees-management/:employeeid",
  Holidays: "/holidays",
  JobManagement: "/admin/job-management",
  JobView: "/admin/job-management/:jobid",
  JobEmployeeView: "/admin/job-management/:jobid/:employeeid",
  Settings: "/settings",
  TransportManagement: "/admin/transport-management",
  ScheduleManagement: "/admin/schedule-management",
  ScheduleManagementTaskDetails: "/admin/schedule-management/tasks/:taskId",
  ScheduleManagementTasks: "/admin/schedule-management/tasks",
  EmployeeEngagement: "/admin/employee-engagement",
  CreateEvent: "/admin/employee-engagement/new-event",
  CreateBroadcast: "/admin/employee-engagement/new-broadcast",
  NoticeBoard: "/admin/notice-board",
  CreateNotice: "/admin/notice-board/new-notice",
  EditNotice: "/admin/notice-board/:noticeid/:type",
  InventoryManagement: "/admin/inventory-management",
  InventoryView: "/admin/inventory-management/:inventoryid",
  TransportSummary: "/admin/transport-summary",
  EditEvent: "/admin/employee-engagement/:eventid",
  Tickets: "/admin/tickets",
  TicketDetails: "/admin/tickets/:ticketid",
  ProcurementTicketDetails: "/admin/procurement-tickets/:ticketid",
  MasterData: "/admin/master-data",
  UserPermissions: "/admin/user-permissions",
  AccessManagement: "/admin/access-management",
  ProjectManagement: "/admin/project-management",
  ProjectUserManagement: "/admin/project-user-management",
  // TaskManagement: "/admin/task-management",
  GoalManagement: "/admin/goal-management",
  DeleteAccount: "/account-deletion",
  UserTracking: "/admin/user-tracking",
  Invites: "/admin/user-invites",
  Dwyte: "/admin/dwyte",
  GapAnalysis: "/admin/gap-analysis",
  GapAnalysisCreateTask: "/admin/gap-analysis/create-project",
  GapAnalysisViewProject: "/admin/gap-analysis/view-project",
  // GapAnalysisViewProject: "/admin/gap-analysis/view-project",

  AmtChatService: "/amt-chat-service",
  AmtChatProfileDetails: "/amt-chat-service/profile-details",
  SignupMobileFrRegistration: "/mobile-fr-registration",
  CrowdsourcePayment: "/admin/natural-anchors-payment",
  Crowdsource: "/admin/anchor-stats",

  WorkFromHome: "/admin/work-from-home",
  AcxioRooms: "/admin/acxio-rooms",
  Profiling: "/admin/profiling",
};

export const PATH_HEADERS = {
  [PATH_NAME.Employees]: "All Employees",
  [PATH_NAME.NewEmployee]: "Add New employee",
  [PATH_NAME.EditEmployee]: "Edit employee",
  [PATH_NAME.LEAVE_MANAGEMENT]: "Leave Management",
  [PATH_NAME.LeaveDetails]: "Leave Management",
  [PATH_NAME.JobManagement]: "Job Management",
  [PATH_NAME.DailyAttendance]: "Attendance",
  [PATH_NAME.JobView]: "Job Management",
  [PATH_NAME.TransportManagement]: "Transport Management",
  [PATH_NAME.ScheduleManagement]: "Schedule Management",
  [PATH_NAME.EmployeeEngagement]: "Employee Engagement",
  [PATH_NAME.NoticeBoard]: "Notice Board",
  [PATH_NAME.CreateEvent]: "Create Event",
  [PATH_NAME.CreateBroadcast]: "Create Broadcast",
  [PATH_NAME.CreateNotice]: "Create Notice",
  [PATH_NAME.EditNotice]: "Edit Notice",
  [PATH_NAME.InventoryManagement]: "Inventory Management",
  [PATH_NAME.InventoryView]: "Inventory Management",
  [PATH_NAME.TransportSummary]: "Transport Summary",
  [PATH_NAME.EditEvent]: "Edit Event",
  [PATH_NAME.Tickets]: "Tickets",
  [PATH_NAME.TicketDetails]: "Tickets",
  [PATH_NAME.ProcurementTicketDetails]: "Tickets",
  [PATH_NAME.MasterData]: "Master Data",
  [PATH_NAME.UserPermissions]: "User Permissions",
  [PATH_NAME.AccessManagement]: "Access Management",
  [PATH_NAME.ProjectManagement]: "Work Updates",
  [PATH_NAME.ProjectUserManagement]: "Work Updates",
  // [PATH_NAME.TaskManagement]: "Task Management",
  [PATH_NAME.GoalManagement]: "Tracker",
  [PATH_NAME.UserTracking]: "User Tracking",

  [PATH_NAME.Invites]: "Invites",
  [PATH_NAME.GapAnalysis]: "Gap Analysis",
  [PATH_NAME.GapAnalysisCreateTask]: "Gap Analysis",

  [PATH_NAME.AmtChatService]: "Amt Chat Service",
  [PATH_NAME.AmtChatProfileDetails]: "Profile Details",
  [PATH_NAME.CrowdsourcePayment]: "Natural Anchors Payments",
  [PATH_NAME.Crowdsource]: "Anchor Stats",

  [PATH_NAME.WorkFromHome]: "Work from Home",
  [PATH_NAME.AmtChatProfileDetails]: "My Profile Details",
  [PATH_NAME.AcxioRooms]: "Acxio Hubs",
  [PATH_NAME.Profiling]: "Profiling",
};

export const PATH_SUB_HEADERS = {
  [PATH_NAME.Employees]: "All Employee Information",
  [PATH_NAME.JobManagement]: "Jobs List",
  [PATH_NAME.JobView]: "Job Description",
  [PATH_NAME.JobEmployeeView]: "Profile",
  [PATH_NAME.CreateEvent]: "Create Event",
  [PATH_NAME.EditEvent]: "Edit Event",
  [PATH_NAME.EmployeeEngagement]: "Employee Engagement",
  [PATH_NAME.CreateBroadcast]: "Create Broadcast",
  [PATH_NAME.NoticeBoard]: "Notice Board",
  [PATH_NAME.CreateNotice]: "Create Notice",
  [PATH_NAME.EditNotice]: "Edit Notice",
  [PATH_NAME.LEAVE_MANAGEMENT]: "Leave Management",
  [PATH_NAME.LeaveDetails]: "Leave Details",

  [PATH_NAME.InventoryManagement]: "Inventory Management",
  [PATH_NAME.InventoryView]: "Device Details",
  [PATH_NAME.TransportSummary]: "Transport Summary",
  [PATH_NAME.TransportManagement]: "Transport Management",
  [PATH_NAME.ScheduleManagement]: "Schedule Management",
  [PATH_NAME.Tickets]: "Tickets",
  [PATH_NAME.ProcurementTicketDetails]: "Procurement Ticket Details",

  [PATH_NAME.MasterData]: "Master Data",
  [PATH_NAME.TicketDetails]: "Ticket Details",
  [PATH_NAME.UserPermissions]: "User Permissions",
  [PATH_NAME.AccessManagement]: "Access Management",
  // [PATH_NAME.TaskManagement]: "Task Management",
  [PATH_NAME.GoalManagement]: "Tracker",
  [PATH_NAME.UserTracking]: "User Tracking",

  [PATH_NAME.Invites]: "Invites",
  [PATH_NAME.GapAnalysis]: "Gap Analysis",
  [PATH_NAME.GapAnalysisCreateTask]: "Create goal",
  [PATH_NAME.GapAnalysisViewProject]: "View Project",
  [PATH_NAME.ScheduleManagementTaskDetails]: "Details",
  [PATH_NAME.ScheduleManagementTasks]: "Tasks",
  [PATH_NAME.CrowdsourcePayment]: "Natural Anchors Payments",
  [PATH_NAME.Crowdsource]: "Anchor Stats",
  [PATH_NAME.WorkFromHome]: "Work from Home",
  [PATH_NAME.AcxioRooms]: "Acxio Hubs",
  [PATH_NAME.Profiling]: "Profiling",
};

export const PATH_MODULES = {
  [PATH_NAME.MasterData]: 3,
  [PATH_NAME.ScheduleManagement]: 4,
  [PATH_NAME.TransportManagement]: 5,
  [PATH_NAME.DailyAttendance]: 6,
  [PATH_NAME.Employees]: 8 || 1,
  [PATH_NAME.LEAVE_MANAGEMENT]: 9 || 2,
  [PATH_NAME.LeaveDetails]: 9 || 2,
  [PATH_NAME.EmployeeEngagement]: 10,
  [PATH_NAME.Tickets]: 11,
  [PATH_NAME.InventoryManagement]: 14,
  [PATH_NAME.JobManagement]: 13,
  [PATH_NAME.UserPermissions]: 1,
  [PATH_NAME.ProjectManagement]: 19,
  [PATH_NAME.GoalManagement]: 18,
  [PATH_NAME.NoticeBoard]: 20,
  [PATH_NAME.ProjectUserManagement]: 21,
  [PATH_NAME.UserTracking]: 23,
  [PATH_NAME.Invites]: 22,
  [PATH_NAME.GapAnalysis]: 12,
  [PATH_NAME.CrowdsourcePayment]: 29,
  [PATH_NAME.Crowdsource]: 12,
  [PATH_NAME.WorkFromHome]: 12,
  [PATH_NAME.AmtChatProfileDetails]: 26,
  [PATH_NAME.AcxioRooms]: 12,
  [PATH_NAME.Profiling]: 12,
};
